import { createTranslations } from '@npco/common-utils-translations'

export const contactTransferFieldTranslations = createTranslations({
  transferHoldDisclaimer: 'Some transfers may be held for up to 24 hours.',
  dailyMaxLimitExceedError:
    'This amount exceeds your Daily Maximum Limit. Please contact Zeller Support to raise your limit.',
  amountRequired: 'Amount is required.',
})
